import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/contexts/AppContext";
import Index from "./pages/Index";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import OnboardingPage from "./pages/OnboardingPage";
import DashboardPage from "./pages/DashboardPage";
import GenerateReviewPage from "./pages/GenerateReviewPage";
import CategoriesPage from "./pages/CategoriesPage";
import PostReviewPage from "./pages/PostReviewPage";
import HistoryPage from "./pages/HistoryPage";
import SettingsPage from "./pages/SettingsPage";
import CustomerReviewPage from "./pages/CustomerReviewPage";
import NotFound from "./pages/NotFound";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import ContactPage from "./pages/ContactPage";

// Industry Pages
import HealthcarePage from "./pages/industries/HealthcarePage";
import RealEstatePage from "./pages/industries/RealEstatePage";
import RestaurantsPage from "./pages/industries/RestaurantsPage";
import EducationPage from "./pages/industries/EducationPage";
import SalonWellnessPage from "./pages/industries/SalonWellnessPage";
import AutomobilePage from "./pages/industries/AutomobilePage";
import HomeServicesPage from "./pages/industries/HomeServicesPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AppProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/generate" element={<GenerateReviewPage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/post-review" element={<PostReviewPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/review/:businessId" element={<CustomerReviewPage />} />
            
            {/* Industry Landing Pages */}
            <Route path="/industries/healthcare" element={<HealthcarePage />} />
            <Route path="/industries/real-estate" element={<RealEstatePage />} />
            <Route path="/industries/restaurants" element={<RestaurantsPage />} />
            <Route path="/industries/education" element={<EducationPage />} />
            <Route path="/industries/salon-wellness" element={<SalonWellnessPage />} />
            <Route path="/industries/automobile" element={<AutomobilePage />} />
            <Route path="/industries/home-services" element={<HomeServicesPage />} />
            
            {/* Legal Pages */}
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/contact" element={<ContactPage />} />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AppProvider>
  </QueryClientProvider>
);

export default App;
